import { createContext, useContext } from 'react'

interface ContextValue {
  lng?: string
}

export const LanguageContext = createContext<ContextValue>({})

export const useLanguageContext = () => useContext(LanguageContext)
